// examples/index.ts
import {
  createHttpBackend,
  createSQLiteHTTPPool
} from 'sqlite-wasm-http';

(async function main() {
  // 1) Setup HTTP-VFS & pool
  const httpBackend = createHttpBackend({
    maxPageSize: 64 * 1024,  // 64 KiB per range
    cacheSize:   16 * 1024,  // ~16 MiB cache
    timeout:     30_000
  });
  const pool = await createSQLiteHTTPPool({
    workers: 8
  });

  // 2) UI refs
  const selectCountry = document.getElementById('select-country') as HTMLSelectElement;
  const inputSearch   = document.getElementById('input-search')   as HTMLInputElement;
  const btnSearch     = document.getElementById('btn-search')!;
  const resultsPane   = document.querySelector('.results-pane')! as HTMLElement;
  const reportViewer  = document.getElementById('report-viewer') as HTMLIFrameElement;

  // 3) Open DB
  await pool.open( 'https://raw.githubusercontent.com/ndmvisuals/cdn/main/sample_per_country.sqlite');

  // 4) Search handler
  btnSearch.addEventListener('click', async () => {
    const slug = selectCountry.value;
    const term = inputSearch.value.trim();
    if (!slug) {
      alert('Please select a country.');
      return;
    }
    if (!term) {
      alert('Please enter a search term.');
      return;
    }

    // clear old results & hide viewer
    resultsPane.innerHTML = '';
    reportViewer.style.display = 'none';

    // ↓↓↓ UPDATED SQL: no alias for MATCH ↓↓↓
    const ftsName = `notes_fts_${slug}`;
    const sql = `
      SELECT
        ${ftsName}.rowid                             AS id,
        snippet(${ftsName}, 0, '<b>','</b>','…', 10) AS title_snip,
        snippet(${ftsName}, 1, '<b>','</b>','…', 20) AS body_snip,
        n.url                                        AS html_url
      FROM ${ftsName}
      JOIN notes AS n
        ON n.id = ${ftsName}.rowid
      WHERE ${ftsName} MATCH $term
      LIMIT 50;
    `;

    try {
      const rows = await pool.exec(sql, { $term: term });

      for (const { row } of rows) {
        const [ id, title_snip, body_snip, html_url ] =
          row as [number, string, string, string];

        // combine & strip for highlighting
        const plainPhrase = (title_snip + ' ' + body_snip)
          .replace(/<[^>]+>/g, '')
          .trim();

        // render list-group item
        const item = document.createElement('div');
        item.className = 'list-group-item d-flex justify-content-between align-items-start';
        item.innerHTML = `
          <div>
            <strong>ID ${id}</strong><br>
            <div><em>Title:</em> ${title_snip}</div>
            <div><em>Body:</em>  ${body_snip}</div>
          </div>
          <button class="btn btn-sm btn-outline-secondary view-html"
                  data-html="${html_url}"
                  data-snippet="${encodeURIComponent(plainPhrase)}">
            View 2023
          </button>
        `;
        resultsPane.append(item);
      }
    } catch (e: any) {
      console.error(e);
      alert('Search error: ' + (e.result?.message || e.toString()));
    }
  });

  // 5) Delegate “View 2023” clicks
  resultsPane.addEventListener('click', (evt) => {
    const btn = (evt.target as HTMLElement)
      .closest('.view-html') as HTMLButtonElement;
    if (!btn) return;

    const url     = btn.dataset.html!;
    const snippet = decodeURIComponent(btn.dataset.snippet!);

    // show & load iframe
    reportViewer.src = url;
    reportViewer.style.display = 'block';

    // highlight on load
    reportViewer.onload = () => {
      const doc = reportViewer.contentDocument;
      if (doc) highlightPhrase(doc.body, snippet);
    };
  });

  // 6) Highlight helper
  function highlightPhrase(root: HTMLElement, phrase: string) {
    if (!phrase) return;
    const regex = new RegExp(escapeRegExp(phrase), 'gi');
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const toHighlight: Text[] = [];
    let node: Node | null;
    while (node = walker.nextNode()) {
      if (regex.test(node.nodeValue || '')) {
        toHighlight.push(node as Text);
      }
    }
    for (const textNode of toHighlight) {
      const frag = document.createDocumentFragment();
      const txt  = textNode.nodeValue!;
      let last   = 0;
      txt.replace(regex, (match, offset) => {
        frag.append(txt.slice(last, offset));
        const mark = document.createElement('mark');
        mark.className = 'highlight';
        mark.textContent = match;
        frag.append(mark);
        last = offset + match.length;
        return match;
      });
      frag.append(txt.slice(last));
      textNode.parentNode!.replaceChild(frag, textNode);
    }
  }
  function escapeRegExp(s: string) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // 7) Cleanup
  window.addEventListener('unload', async () => {
    await pool.close();
    await httpBackend.close();
  });
})();
